import { useEffect, useMemo, useRef, useState } from "react"
import { enumUtil } from "../../../../../../../../utils/Enum"
import { ServerRequestProtected, ServerRequestPublic } from "../../../../../../../../utils/ServerDataRequest"
import NotificationHandler from "../../../../../../../../utils/NotificationHandler"
import { IconAiSingle, IconAlertGradient, IconPause } from "../../../../../../../shared/IconsComponent/icons"
import store from "../../../../../../../../store"
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import { Modal } from "react-bootstrap"
import AIEncounterTranscriptPreview from "./AIEncounterTranscriptPreview"
import SuperSearchList from "../../../../../../../shared/SuperSearch/SuperSearchList"
import AIEncounterSummaryPreview from "./AIEncounterSummaryPreview"
import AIDiscardRecordingModal from "./AIDiscardRecordingModal"
import isNull from "../../../../../../../../utils/NullChecking"
import AIDiscardTranscriptModal from "./AIDiscardTranscriptModal"
import { GeneralDropDowns } from "../../../../../../../../actions/GeneralPatientActions"
import { useDispatch, useSelector } from "react-redux"
import Loader from "../../../../../../../shared/Loader/Loader"
import { saveAs } from "file-saver"
const AIEncounter = (props) => {
    const { audioPopup, handleCloseAudio, initialData, handleAddEncounter, setShowAiIcon, setEncounterData, reRecordAI, setReRecordAI, resumeAI, setResumeAI } = { ...props }
    const API_URL_AI = enumUtil.controller.AINoteWorkflows
    const API_URL_GENERATENOTE = enumUtil.controller.GenerateNote
    const API_URL = enumUtil.controller.PatientEncounter
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    const encounterId = initialData?.Data?.EncounterID
    let activeRecordingEncounterIdExists = useSelector(state => state.ResumeAISessionReducer)?.activeRecordingEncounterId ?? '';
    let openAIPopup = useSelector(state => state.ResumeAISessionReducer)?.openAIPopup ?? '';
    let dispatch = useDispatch();

    // display or hide ai encounter popup
    const [showAiEncounterPopup, setShowAiEncounterPopup] = useState(true)

    // discard popup
    const [confimarionPopup, setConfirmationPopup] = useState(false)
    const [transcriptConfirmation, setTranscriptConfirmation] = useState(false)
    const [generatedNoteConfirmation, setgeneratedNoteConfirmation] = useState(false)
    const isDiscardingRef = useRef(false);
    // states
    const mediaRecorderRef = useRef(null);
    const streamRef = useRef(null);
    const chunksRef = useRef([]);
    const audioRef = useRef(null);
    const timerRef = useRef(null);
    const durationRef = useRef(0);

    const [isRecording, setIsRecording] = useState(false);
    const [isPaused, setIsPaused] = useState(false);
    const [audioURL, setAudioURL] = useState(null);
    const [duration, setDuration] = useState(0);
    const [activeTab, setActiveTab] = useState("transcript");
    const [generatingTranscript, setGeneratingTranscript] = useState(false)
    const [isTranscriptGenerated, setIsTranscriptGenerated] = useState(false)
    const [promptDescription, setpromptDescription] = useState('')
    const [promptName, setPromptName] = useState('');
    const [isOnlineAppointment, setIsOnlineAppointment] = useState(false);
    // AI note taker functions
    const [generatedNotes, setGeneratedNotes] = useState()
    const [isGeneratingNotes, setisGeneratingNotes] = useState({
        generatingNotes: false,
        Progress: null,
        taskStatus: '',
        Message: ''
    })
    const [transcriptedData, setTranscriptedData] = useState({
        transcript: '',
        clinicalAINoteJobsID: '',
        transcriptID: '',
        transcriptStatus: '',
    })
    const [emptyTranscript, setEmptyTranscript] = useState(false)
    const abortControllerRef = useRef(null);
    const [nextStep, setNextStep] = useState('')
    const isApplyingStepRef = useRef(false);
    const SECTION_ORDER = [
        "data",
        "assessment",
        "progress",
        "plan"
    ];
    const getOrderedResponse = (response) => {
        return SECTION_ORDER.reduce((acc, key) => {
            if (response?.[key]) {
                acc[key] = response[key];
            }
            return acc;
        }, {});
    };
    const handleStart = () => {
        if (isOnlineAppointment) {
            handleStartRecordingTele()
        } else {
            handleStartRecording()
        }
    }
    const handleUploadAudio = (audioBlob) => {
        if (initialData?.Data?.IsGroupEncounter === 'true') {
            UploadGroupAudio(audioBlob)
        } else {
            UploadAudio(audioBlob)
        }
    }
    const UploadAudio = (audioBlob) => {
        const formData = new FormData();
        formData.append("AudioFile", audioBlob, "audio.webm");
        formData.append('PatientID', initialData.Data.PatientID);
        formData.append('PatientAppointmentID', initialData.Data.PatientAppointmentID ? initialData.Data.PatientAppointmentID : '0');
        formData.append('NoteType', initialData?.Data?.NoteType ? initialData?.Data?.NoteType : '');
        formData.append('EncounterID', initialData?.Data?.EncounterID ? initialData?.Data?.EncounterID : '0');
        abortControllerRef.current = new AbortController();

        ServerRequestPublic(API_URL_AI + "/UploadAudio", 'post', formData, 'Upload', abortControllerRef.current.signal)
            .then((response) => {
                getAIFormDetails()
                abortControllerRef.current = null;
                setIsTranscriptGenerated(true)
                setIsRecording(null);
                setGeneratingTranscript(false)
                if (isNull(response.transcript)) {
                    setEmptyTranscript(true)
                }
                setTranscriptedData(response)
                // if(response.prompt){
                setpromptDescription(response.prompt)
                setPromptName(response.promptname || '');
                // }
                setActiveTab("transcript")
            }).catch((error) => {
                setEmptyTranscript(true)
                if (
                    error?.name === "CanceledError" ||
                    error?.code === "ERR_CANCELED"
                ) {
                    console.log("UploadAudio aborted");
                    return;
                }
                setGeneratingTranscript(false)
                setIsTranscriptGenerated(false)
                NotificationHandler("Failed to upload audio. Please try again.", enumUtil.enumtoaster.error);
            })
    }
    const UploadGroupAudio = (audioBlob) => {
        const formData = new FormData();
        formData.append("AudioFile", audioBlob, "audio.webm");
        // formData.append('PatientID', initialData.Data.PatientID);
        // formData.append('PatientAppointmentID', initialData.Data.PatientAppointmentID ? initialData.Data.PatientAppointmentID : '0');
        formData.append('NoteType', initialData?.Data?.NoteType ? initialData?.Data?.NoteType : '');
        formData.append('EncounterID', initialData?.Data?.EncounterID ? initialData?.Data?.EncounterID : '0');
        formData.append('GroupAppointmentIdentifier', initialData?.Data?.GroupIdentifier ? initialData?.Data?.GroupIdentifier : '0');
        abortControllerRef.current = new AbortController();

        ServerRequestPublic(API_URL_AI + "/UploadGroupAudio", 'post', formData, 'Upload', abortControllerRef.current.signal)
            .then((response) => {
                getAIFormDetails()
                abortControllerRef.current = null;
                setIsTranscriptGenerated(true)
                setIsRecording(null);
                setGeneratingTranscript(false)
                setTranscriptedData(response)
                // if(response.prompt){
                setpromptDescription(response.prompt)
                setPromptName(response.promptname || '');
                // }
                setActiveTab("transcript")
                if (isNull(response.transcript)) {
                    setEmptyTranscript(true)
                }
            }).catch((error) => {
                if (
                    error?.name === "CanceledError" ||
                    error?.code === "ERR_CANCELED"
                ) {
                    console.log("UploadAudio aborted");
                    return;
                }
                setEmptyTranscript(true)
                setGeneratingTranscript(false)
                setIsTranscriptGenerated(false)
                NotificationHandler(error.response.data.error, enumUtil.enumtoaster.error);
            })
    }
    const startTimer = () => {
        timerRef.current = setInterval(() => {
            setDuration((prev) => {
                const next = prev + 1;
                durationRef.current = next;

                dispatch({
                    type: "UPDATE_RECORDING_TIMER",
                    // payload: next,
                    payload: { encounterId, duration: next }
                });
                return next;
            });
        }, 1000);
    };
    const stopTimer = () => {
        clearInterval(timerRef.current);
    };
    const formatTime = (sec) => {
        const m = String(Math.floor(sec / 60)).padStart(2, "0");
        const s = String(sec % 60).padStart(2, "0");
        return `${m}:${s}`;
    };
    // Pause
    const pauseRecording = () => {
        mediaRecorderRef.current.pause();
        setIsPaused(true);
        stopTimer();
    };
    // Resume
    const resumeRecording = () => {
        mediaRecorderRef.current.resume();
        setIsPaused(false);
        startTimer();
    };
    // Stop
    // const stopRecording = () => {
    //     mediaRecorderRef.current.stop(); // triggers onstop → UploadAudio
    //     stopTimer();
    //     setIsRecording(null);
    //     setIsPaused(false);
    //     streamRef.current.getTracks().forEach((track) => track.stop());
    // };
    const stopRecording = () => {
        mediaRecorderRef.current.stop();
        stopTimer();
        setIsRecording(null);
        setIsPaused(false);
        // dispatch(GeneralDropDowns({ ...DropDowns, isRecordingStarted: false }))
        dispatch({ type: "RECORDING_STOPPED", payload: { encounterId } });
        // Stop all tracks from both streams
        streamRef._micStream?.getTracks().forEach(t => t.stop());
        streamRef._displayStream?.getTracks().forEach(t => t.stop());
        streamRef.current?.getTracks().forEach(t => t.stop());
    };
    // Cleanup
    useEffect(() => {
        return () => {
            // abortControllerRef.current?.abort();
            if (audioURL) URL.revokeObjectURL(audioURL);
            stopTimer();
        };
    }, [audioURL]);

    const isStartingRef = useRef(false);

    const handleStartRecording = async () => {
        // testUpload()
        if (activeRecordingEncounterIdExists) {
            NotificationHandler('You already have an active AI recording in another encounter.', enumUtil.enumtoaster.error)
            return
        } else {
            // dispatch(GeneralDropDowns({ ...DropDowns, isRecordingStarted: true }))
            dispatch({ type: "UPDATE_RECORDING_TIMER", payload: encounterId });
        }
        if (isStartingRef.current || (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive")) {
            return;
        }
        isStartingRef.current = true;
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                audio: {
                    echoCancellation: true,
                    noiseSuppression: true,
                    sampleRate: 44100,
                },
            });

            streamRef.current = stream;
            const mediaRecorder = new MediaRecorder(stream);

            mediaRecorderRef.current = mediaRecorder;
            chunksRef.current = [];

            mediaRecorder.ondataavailable = (e) => {
                if (e.data.size > 0) {
                    chunksRef.current.push(e.data);
                }
            };
            mediaRecorder.onstop = () => {
                if (isDiscardingRef.current) {
                    isDiscardingRef.current = false;
                    chunksRef.current = [];
                    return;
                }
                if (durationRef.current === 0) {
                    return
                }
                if (durationRef.current < 15) {
                    handleCloseAudioPopup()
                    NotificationHandler("Recording is too short. Please record at least 15 seconds before generating a transcript.", enumUtil.enumtoaster.warning)
                    return
                }
                const blob = new Blob(chunksRef.current, {
                    type: "audio/webm",
                });
                const url = URL.createObjectURL(blob);
                setAudioURL(url);

                // ✅ Chunks are fully collected here — safe to call API
                handleUploadAudio(blob);
                setGeneratingTranscript(true);
            };

            mediaRecorder.start();
            setIsRecording(true);
            setIsPaused(false);
            startTimer();
        } catch (err) {
            alert("Microphone permission denied or not available.");
        } finally {
            isStartingRef.current = false;
        }
    }

    // const handleStartRecording = async () => {
    //     if (isStartingRef.current || (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive")) return;
    //     isStartingRef.current = true;

    //     try {
    //         // Capture screen/tab WITH system audio (patient voice from Teams)
    //         const displayStream = await navigator.mediaDevices.getDisplayMedia({
    //             video: true,          // required to trigger the picker, we discard video tracks
    //             audio: {
    //                 echoCancellation: false,
    //                 noiseSuppression: false,
    //                 sampleRate: 44100,
    //             }
    //         });

    //         // Capture provider's mic separately
    //         const micStream = await navigator.mediaDevices.getUserMedia({
    //             audio: {
    //                 echoCancellation: true,
    //                 noiseSuppression: true,
    //                 sampleRate: 44100,
    //             }
    //         });

    //         // Stop video tracks — we only need audio
    //         displayStream.getVideoTracks().forEach(track => track.stop());

    //         // Mix both audio streams via Web Audio API
    //         const audioContext = new AudioContext();
    //         const destination = audioContext.createMediaStreamDestination();

    //         const displaySource = audioContext.createMediaStreamSource(displayStream);
    //         const micSource = audioContext.createMediaStreamSource(micStream);

    //         displaySource.connect(destination);
    //         micSource.connect(destination);

    //         const mixedStream = destination.stream;

    //         streamRef.current = mixedStream;

    //         // Store mic + display streams separately for cleanup
    //         streamRef._micStream = micStream;
    //         streamRef._displayStream = displayStream;

    //         const mediaRecorder = new MediaRecorder(mixedStream);
    //         mediaRecorderRef.current = mediaRecorder;
    //         chunksRef.current = [];

    //         mediaRecorder.ondataavailable = (e) => {
    //             if (e.data.size > 0) chunksRef.current.push(e.data);
    //         };

    //         mediaRecorder.onstop = () => {
    //             const blob = new Blob(chunksRef.current, { type: "audio/webm" });
    //             const url = URL.createObjectURL(blob);
    //             setAudioURL(url);
    //             UploadAudio(blob);
    //             setGeneratingTranscript(true);

    //             // Cleanup audio context
    //             audioContext.close();
    //         };

    //         mediaRecorder.start();
    //         setIsRecording(true);
    //         setIsPaused(false);
    //         startTimer();

    //     } catch (err) {
    //         console.log("Error starting recording:", err);
    //         if (err.name === 'NotAllowedError') {
    //             NotificationHandler("Screen share permission denied. Please allow screen sharing to capture both voices.", enumUtil.enumtoaster.error);
    //         } else {
    //             NotificationHandler("Could not start recording. Please try again.", enumUtil.enumtoaster.error);
    //         }
    //     } finally {
    //         isStartingRef.current = false;
    //     }
    // };
    // const handleStartRecording = async () => {
    //     if (isStartingRef.current || (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive")) return;
    //     isStartingRef.current = true;

    //     let displayStream = null;
    //     let micStream = null;

    //     try {
    //         // Step 1: Capture mic first (always required)
    //         micStream = await navigator.mediaDevices.getUserMedia({
    //             audio: {
    //                 echoCancellation: true,
    //                 noiseSuppression: true,
    //                 sampleRate: 44100,
    //             }
    //         });

    //         // Step 2: Try to capture screen/tab with system audio
    //         try {
    //             displayStream = await navigator.mediaDevices.getDisplayMedia({
    //                 video: true,
    //                 audio: {
    //                     echoCancellation: false,
    //                     noiseSuppression: false,
    //                     sampleRate: 44100,
    //                 }
    //             });
    //         } catch (displayErr) {
    //             // User cancelled the screen share picker — that's fine, just proceed mic-only
    //             displayStream = null;
    //         }

    //         // Stop video tracks immediately — we only need audio
    //         displayStream?.getVideoTracks().forEach(track => track.stop());

    //         const hasDisplayAudio = displayStream && displayStream.getAudioTracks().length > 0;

    //         let finalStream;
    //         const audioContext = new AudioContext();

    //         if (hasDisplayAudio) {
    //             // Mix mic + system audio
    //             const destination = audioContext.createMediaStreamDestination();
    //             const displaySource = audioContext.createMediaStreamSource(displayStream);
    //             const micSource = audioContext.createMediaStreamSource(micStream);

    //             displaySource.connect(destination);
    //             micSource.connect(destination);

    //             finalStream = destination.stream;
    //         } else {
    //             // No system audio available — fall back to mic-only
    //             finalStream = micStream;

    //             NotificationHandler(
    //                 "Only your microphone will be recorded. To capture the patient's audio, share a browser tab and check 'Share tab audio'.",
    //                 enumUtil.enumtoaster.warning
    //             );
    //         }

    //         streamRef.current = finalStream;
    //         streamRef._micStream = micStream;
    //         streamRef._displayStream = displayStream;
    //         streamRef._audioContext = audioContext;

    //         const mediaRecorder = new MediaRecorder(finalStream);
    //         mediaRecorderRef.current = mediaRecorder;
    //         chunksRef.current = [];

    //         mediaRecorder.ondataavailable = (e) => {
    //             if (e.data.size > 0) chunksRef.current.push(e.data);
    //         };

    //         mediaRecorder.onstop = () => {
    //             const blob = new Blob(chunksRef.current, { type: "audio/webm" });
    //             const url = URL.createObjectURL(blob);
    //             setAudioURL(url);
    //             UploadAudio(blob);
    //             setGeneratingTranscript(true);
    //             audioContext.close();
    //         };

    //         mediaRecorder.start();
    //         setIsRecording(true);
    //         setIsPaused(false);
    //         startTimer();

    //     } catch (err) {
    //         // Mic itself failed/denied — nothing we can do
    //         micStream?.getTracks().forEach(t => t.stop());
    //         displayStream?.getTracks().forEach(t => t.stop());

    //         if (err.name === 'NotAllowedError') {
    //             NotificationHandler("Microphone permission denied. Please allow microphone access to start recording.", enumUtil.enumtoaster.error);
    //         } else {
    //             NotificationHandler("Could not start recording. Please try again.", enumUtil.enumtoaster.error);
    //         }
    //     } finally {
    //         isStartingRef.current = false;
    //     }
    // };


    // const handleStartRecording = async () => {
    //     if (isStartingRef.current || (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive")) return;
    //     isStartingRef.current = true;

    //     let displayStream = null;
    //     let micStream = null;

    //     try {
    //         // Step 1: Capture mic first (always required)
    //         micStream = await navigator.mediaDevices.getUserMedia({
    //             audio: {
    //                 echoCancellation: true,
    //                 noiseSuppression: true,
    //                 sampleRate: 44100,
    //             }
    //         });

    //         // Step 2: Try to capture screen/tab with system audio
    //         try {
    //             // displayStream = await navigator.mediaDevices.getDisplayMedia({
    //             //     video: true,
    //             //     audio: {
    //             //         echoCancellation: false,
    //             //         noiseSuppression: false,
    //             //         sampleRate: 44100,
    //             //     }
    //             // });
    //             displayStream = await navigator.mediaDevices.getDisplayMedia({
    //                 video: {
    //                     displaySurface: "monitor"
    //                 },
    //                 audio: {
    //                     echoCancellation: false,
    //                     noiseSuppression: false,
    //                     sampleRate: 44100,
    //                 },
    //                 preferCurrentTab: false,
    //                 selfBrowserSurface: "exclude",
    //                 surfaceSwitching: "exclude",
    //                 monitorTypeSurfaces: "include"
    //             });
    //             // Validate that the user selected "Entire Screen"
    //             const videoTrack = displayStream.getVideoTracks()[0];

    //             if (videoTrack) {
    //                 const surface = videoTrack.getSettings().displaySurface;

    //                 if (surface !== "monitor") {
    //                     displayStream.getTracks().forEach(track => track.stop());

    //                     NotificationHandler(
    //                         "Please select 'Entire Screen' to continue.",
    //                         enumUtil.enumtoaster.warning
    //                     );

    //                     return;
    //                 }
    //             }
    //             displayStream.getVideoTracks().forEach(track => track.stop());

    //         } catch (displayErr) {
    //             // User cancelled the screen share picker — that's fine, just proceed mic-only
    //             displayStream = null;
    //         }

    //         // Stop video tracks immediately — we only need audio
    //         displayStream?.getVideoTracks().forEach(track => track.stop());

    //         const hasDisplayAudio = displayStream && displayStream.getAudioTracks().length > 0;

    //         let finalStream;
    //         const audioContext = new AudioContext();

    //         if (hasDisplayAudio) {
    //             // Mix mic + system audio
    //             const destination = audioContext.createMediaStreamDestination();
    //             const displaySource = audioContext.createMediaStreamSource(displayStream);
    //             const micSource = audioContext.createMediaStreamSource(micStream);

    //             displaySource.connect(destination);
    //             micSource.connect(destination);

    //             finalStream = destination.stream;
    //         } else {
    //             // No system audio available — fall back to mic-only
    //             micStream?.getTracks().forEach(track => track.stop());
    //             displayStream?.getTracks().forEach(track => track.stop());
    //             audioContext.close();

    //             NotificationHandler(
    //                 "Recording cannot be started because system audio was not shared. Please select 'Entire Screen' and enable 'Share system audio', then try again.",
    //                 enumUtil.enumtoaster.warning
    //             );

    //             return;
    //         }

    //         streamRef.current = finalStream;
    //         streamRef._micStream = micStream;
    //         streamRef._displayStream = displayStream;
    //         streamRef._audioContext = audioContext;

    //         const mediaRecorder = new MediaRecorder(finalStream);
    //         mediaRecorderRef.current = mediaRecorder;
    //         chunksRef.current = [];

    //         mediaRecorder.ondataavailable = (e) => {
    //             if (e.data.size > 0) chunksRef.current.push(e.data);
    //         };

    //         mediaRecorder.onstop = () => {
    //             const blob = new Blob(chunksRef.current, { type: "audio/webm" });
    //             const url = URL.createObjectURL(blob);
    //             setAudioURL(url);
    //             UploadAudio(blob);
    //             setGeneratingTranscript(true);
    //             audioContext.close();
    //         };

    //         mediaRecorder.start();
    //         setIsRecording(true);
    //         setIsPaused(false);
    //         startTimer();

    //     } catch (err) {
    //         // Mic itself failed/denied — nothing we can do
    //         micStream?.getTracks().forEach(t => t.stop());
    //         displayStream?.getTracks().forEach(t => t.stop());

    //         if (err.name === 'NotAllowedError') {
    //             NotificationHandler("Microphone permission denied. Please allow microphone access to start recording.", enumUtil.enumtoaster.error);
    //         } else {
    //             NotificationHandler("Could not start recording. Please try again.", enumUtil.enumtoaster.error);
    //         }
    //     } finally {
    //         isStartingRef.current = false;
    //     }
    // };
    const GenerateNotes = () => {
        if (emptyTranscript) {
            NotificationHandler("No transcription is available for this recording. Please record the session again to generate a note.", enumUtil.enumtoaster.error)
            handleCloseAudioPopup()
        } else {
            if (initialData?.Data.IsGroupEncounter === 'true') {
                handleGenerateGroupNote()
            } else {
                handleGenerateNote()
            }
        }

    }
    const handleGenerateNote = async () => {
        setisGeneratingNotes(prev => ({
            ...prev,
            generatingNotes: true
        }));

        const token = store.getState().Login.token;

        const response = await fetch(
            `${process.env.REACT_APP_API}${API_URL_AI}/${API_URL_GENERATENOTE}`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    ClinicalAINoteJobsID: transcriptedData.clinicalAINoteJobsID,
                    TranscriptID: transcriptedData.transcriptID,
                    Prompt: promptDescription
                })
            }
        );

        const reader = response.body.getReader();
        const decoder = new TextDecoder();

        while (true) {
            const { value, done } = await reader.read();
            if (done) break;

            const chunk = decoder.decode(value);
            const matches = chunk.match(/data:\s*(.+)/g);

            if (matches) {
                matches.forEach(item => {
                    const jsonString = item.replace("data:", "").trim();

                    try {
                        const parsed = JSON.parse(jsonString);
                        console.log(parsed.Status, parsed.Message, parsed);
                        if (parsed.Status === "progress") {
                            setisGeneratingNotes(prev => ({
                                ...prev,
                                Progress: parsed.Percentage,
                                taskStatus: parsed.Status,
                                Message: parsed.Message
                            }));
                        }

                        if (parsed.Status === "done") {
                            setisGeneratingNotes(prev => ({
                                ...prev,
                                generatingNotes: false,
                                Progress: 100,
                                taskStatus: parsed.Status,
                                Message: parsed.Message
                            }));
                            generateActualNotes();
                        }

                        if (parsed.Status === "failed") {
                            handleCloseAudioPopup()
                            NotificationHandler(parsed.Message, enumUtil.enumtoaster.error)
                        }
                    } catch (e) {
                        setisGeneratingNotes({
                            generatingNotes: false,
                            Progress: null,
                            taskStatus: '',
                            Message: ''
                        });

                        console.error(e);
                    }
                });
            }
        }
    };
    const generateActualNotes = () => {
        ServerRequestProtected(
            `${API_URL_AI}/${transcriptedData.clinicalAINoteJobsID}`,
            'GET'
        ).then((response) => {
            getAIFormDetails()
            setGeneratedNotes(response)
            setActiveTab("note");
        }).catch((error) => {
            NotificationHandler("Failed to get note. Please try again.", enumUtil.enumtoaster.error);
        })
    }
    // Group Note Generation
    const handleGenerateGroupNote = async () => {
        setisGeneratingNotes(prev => ({
            ...prev,
            generatingNotes: true
        }));
        ServerRequestProtected(API_URL_AI + "/GenerateGrpNote", 'post', {
            clinicalAIGroupNoteJobsID: transcriptedData.clinicalAIGroupNoteJobsID,
            TranscriptID: transcriptedData.transcriptID,
            Prompt: promptDescription,
            GroupAppointmentIdentifier: initialData?.Data?.GroupIdentifier ? initialData?.Data?.GroupIdentifier : '0'
        }).then((response) => {
            setisGeneratingNotes(prev => ({
                ...prev,
                generatingNotes: false,
                Progress: 100,
                taskStatus: 'done',
                Message: ''
            }));
            generateActualGroupNotes(response);
        }).catch((error) => {
            setisGeneratingNotes({
                generatingNotes: false,
                Progress: null,
                taskStatus: '',
                Message: ''
            });
            NotificationHandler(error.response.data.error, enumUtil.enumtoaster.error);
        })
    };
    const generateActualGroupNotes = (response) => {
        setGeneratedNotes(response)
        getAIFormDetails()
        setActiveTab("Summary");
    }
    // const closeAudio = () => {
    //     setIsRecording(false);
    //     setIsPaused(false);
    //     setAudioURL(null);
    //     setDuration(0);
    //     setGeneratingTranscript(false)
    //     setIsTranscriptGenerated(false)
    //     setEmptyTranscript(false)
    //     setisGeneratingNotes({
    //         generatingNotes: false,
    //         Progress: null,
    //         taskStatus: '',
    //         Message: ''
    //     });
    //     setGeneratedNotes()
    //     abortControllerRef.current?.abort();
    //     abortControllerRef.current = null;
    //     chunksRef.current = [];
    //     if (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive") {
    //         mediaRecorderRef.current.stop();
    //     }
    //     if (streamRef.current) {
    //         streamRef.current.getTracks().forEach((track) => track.stop());
    //     }
    //     handleCloseAudio()
    // }
    const closeAudio = () => {
        // Recording/session state
        setShowAiEncounterPopup(true)
        setIsRecording(false);
        setIsPaused(false);
        setAudioURL(null);
        setDuration(0);
        durationRef.current = 0;
        setGeneratingTranscript(false);
        setIsTranscriptGenerated(false);
        setEmptyTranscript(false);

        // Notes generation state
        setisGeneratingNotes({
            generatingNotes: false,
            Progress: null,
            taskStatus: '',
            Message: ''
        });
        setGeneratedNotes();

        // Tab / transcript / prompt state
        setActiveTab("transcript");
        setTranscriptedData({
            transcript: '',
            clinicalAINoteJobsID: '',
            transcriptID: '',
            transcriptStatus: '',
        });
        setpromptDescription('');
        setPromptName('');
        setIsPromptExpand(false);

        // Options
        setIsOnlineAppointment(false);

        // Confirmation popups
        setConfirmationPopup(false);
        setTranscriptConfirmation(false);
        setgeneratedNoteConfirmation(false);

        // Abort any in-flight upload
        abortControllerRef.current?.abort();
        abortControllerRef.current = null;
        chunksRef.current = [];

        // Stop media recorder
        if (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive") {
            mediaRecorderRef.current.stop();
        }

        // Stop all tracks — mic-only path uses streamRef.current directly;
        // telehealth path also stashes mic/display streams + AudioContext
        streamRef.current?.getTracks().forEach((track) => track.stop());
        streamRef._micStream?.getTracks().forEach((track) => track.stop());
        streamRef._displayStream?.getTracks().forEach((track) => track.stop());
        if (streamRef._audioContext && streamRef._audioContext.state !== "closed") {
            streamRef._audioContext.close();
        }
        streamRef._micStream = null;
        streamRef._displayStream = null;
        streamRef._audioContext = null;
        // dispatch(GeneralDropDowns({ ...DropDowns, isRecordingStarted: false }))
        dispatch({ type: "RECORDING_STOPPED", payload: { encounterId } });
        handleCloseAudio();
    }
    const handleCloseAudioPopup = () => {
        isDiscardingRef.current = false;
        closeAudio()
    }

    // confirmation popups logic
    const closeAudioPopup = () => {
        if (isRecording) {
            setShowAiEncounterPopup(false)
        } else {
            handleCloseAudioPopup()
        }
        // else if (activeTab === 'transcript' && !isNull(transcriptedData?.transcript)) {
        //     setTranscriptConfirmation(true)
        // } else if (activeTab === 'note' || activeTab === 'Summary') {
        //     if (!isNull(generatedNotes)) {
        //         setTranscriptConfirmation(true)
        //         setgeneratedNoteConfirmation(true)
        //     }
        // }
        // else {
        // }

    }
    //AIDiscardRecordingModal popup
    const closeDiscardRecordingModal = () => {
        setConfirmationPopup(false)
    }
    const discardChanges = () => {
        isDiscardingRef.current = true;
        closeDiscardRecordingModal()
        closeAudio()
        NotificationHandler('Recording discarded successfully.', enumUtil.enumtoaster.success)
    }

    let AIDiscardPopup = ''
    if (confimarionPopup) {
        AIDiscardPopup = <AIDiscardRecordingModal confimarionPopup={confimarionPopup} onClose={closeDiscardRecordingModal} discardChanges={discardChanges} />
    }

    const onCloseTranscriptPopup = () => {
        setTranscriptConfirmation(false)
    }
    const onDiscardTranscriptPopup = () => {
        setTranscriptConfirmation(false)
        handleCloseAudioPopup()
        if (generatedNoteConfirmation) {
            NotificationHandler('Generated note discarded successfully.', enumUtil.enumtoaster.success)
        } else {
            NotificationHandler('Transcription discarded successfully.', enumUtil.enumtoaster.success)
        }
    }
    const ActionFuntion = () => {
        if (generatedNoteConfirmation) {
            AddEncounter()
        } else {
            GenerateNotes()
        }
        onCloseTranscriptPopup()
        closeDiscardRecordingModal()
    }
    let ATranscriptConfirmationPopup = ''
    if (transcriptConfirmation) {
        ATranscriptConfirmationPopup = <AIDiscardTranscriptModal
            confimarionPopup={transcriptConfirmation}
            onClose={onCloseTranscriptPopup}
            discardChanges={onDiscardTranscriptPopup}
            generatedNoteConfirmation={generatedNoteConfirmation}
            ActionFuntion={ActionFuntion}
        />
    }

    const testUpload = async () => {
        const response = await fetch("/assets/Group Therapy.mp3");
        const blob = await response.blob();
        handleUploadAudio(blob);
    };
    // const validatePatientAssignments = () => {
    //     const patientSummaryItems =
    //         generatedNotes?.MainCustomTemplate?.[0]?.Data?.[0]?.items?.filter(
    //             item =>
    //                 item.IsWidget !== "true" &&
    //                 item.content === "Patient Summary"
    //         ) || [];

    //     // Every Patient Summary must have a patient assigned
    //     const unassigned = patientSummaryItems.find(
    //         item => !item.PatientID || item.PatientID === ""
    //     );

    //     if (unassigned) {
    //         return {
    //             isValid: false,
    //             message: "Every patient must be assigned."
    //         };
    //     }

    //     // Duplicate patient assignments are not allowed
    //     const ids = patientSummaryItems
    //         .map(item => String(item.PatientID))
    //         .filter(id => id !== "");

    //     if (new Set(ids).size !== ids.length) {
    //         return {
    //             isValid: false,
    //             message: "Duplicate patient assignments are not allowed."
    //         };
    //     }

    //     return {
    //         isValid: true,
    //         message: ""
    //     };
    // };
    const validatePatientAssignments = () => {
        const repeatedItems =
            generatedNotes?.MainCustomTemplate?.[0]?.Data?.[0]?.items?.filter(
                item =>
                    item.IsRepeated === "true" &&
                    item.IsWidget !== "true"
            ) || [];

        // 1. Every repeated item must have a patient assigned
        const unassigned = repeatedItems.find(
            item => !item.PatientID
        );

        if (unassigned) {
            return {
                isValid: false,
                message: "Every repeated field must be assigned to a patient."
            };
        }

        // 2. Validate duplicates within each ItemID
        const groupedByItem = repeatedItems.reduce((acc, item) => {
            if (!acc[item.ItemID]) {
                acc[item.ItemID] = [];
            }

            acc[item.ItemID].push(item);
            return acc;
        }, {});

        for (const itemId in groupedByItem) {
            const patientIds = groupedByItem[itemId].map(x => String(x.PatientID));

            if (new Set(patientIds).size !== patientIds.length) {
                return {
                    isValid: false,
                    message: "Duplicate patient assignments are not allowed."
                };
            }
        }

        return {
            isValid: true,
            message: ""
        };
    };
    const AddEncounter = () => {
        if (initialData?.Data?.IsGroupEncounter === 'true') {
            let validation = validatePatientAssignments()
            if (!validation.isValid) {
                NotificationHandler(validation.message, enumUtil.enumtoaster.error)
            } else {
                let data = { ...generatedNotes }
                // initialData
                // handleAddEncounter(generatedNotes, transcriptedData.clinicalAINoteJobsID)
                const updatedInitialData = structuredClone(initialData);
                const generatedItems =
                    generatedNotes?.MainCustomTemplate?.[0]?.Data?.[0]?.items || [];
                updatedInitialData.MainCustomTemplate[0].Data[0].items =
                    updatedInitialData.MainCustomTemplate[0].Data[0].items.map(initialItem => {
                        const matchedItem = generatedItems.find(generatedItem => {
                            if (initialItem.IsRepeated === "false") {
                                return generatedItem.ItemID === initialItem.ItemID;
                            }
                            return (
                                generatedItem.ItemID === initialItem.ItemID &&
                                generatedItem.PatientID === initialItem.PatientID
                            );
                        });
                        return matchedItem
                            ? {
                                ...initialItem,
                                answer: matchedItem.answer
                            }
                            : initialItem;
                    });
                handleAddEncounter(updatedInitialData, transcriptedData.clinicalAINoteJobsID)
                handleCloseAudioPopup()
            }
            // setShowAiIcon(false)
        } else {
            handleAddEncounter(generatedNotes, transcriptedData.clinicalAINoteJobsID)
            handleCloseAudioPopup()
            // setShowAiIcon(false)
        }

    }

    // Format dimension key: "dimension_1" → "Dimension 1"
    const formatDimensionKey = (key) => {
        return key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    };

    // Format section key: "withdrawal_intoxication_medication_assessment" → "Withdrawal Intoxication Medication Assessment"
    const formatSectionKey = (key) => {
        return key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    };

    const [isPromptExpand, setIsPromptExpand] = useState(false)
    const handleStartRecordingTele = async () => {
        if (isStartingRef.current || (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive")) return;
        isStartingRef.current = true;

        let displayStream = null;
        let micStream = null;

        try {
            // Step 1: Capture mic first (always required)
            micStream = await navigator.mediaDevices.getUserMedia({
                audio: {
                    echoCancellation: true,
                    noiseSuppression: true,
                    sampleRate: 44100,
                }
            });

            // Step 2: Try to capture screen/tab with system audio
            try {
                // displayStream = await navigator.mediaDevices.getDisplayMedia({
                //     video: true,
                //     audio: {
                //         echoCancellation: false,
                //         noiseSuppression: false,
                //         sampleRate: 44100,
                //     }
                // });
                displayStream = await navigator.mediaDevices.getDisplayMedia({
                    video: {
                        displaySurface: "monitor"
                    },
                    audio: {
                        echoCancellation: false,
                        noiseSuppression: false,
                        sampleRate: 44100,
                    },
                    preferCurrentTab: false,
                    selfBrowserSurface: "exclude",
                    surfaceSwitching: "exclude",
                    monitorTypeSurfaces: "include"
                });
                // Validate that the user selected "Entire Screen"
                const videoTrack = displayStream.getVideoTracks()[0];

                if (videoTrack) {
                    const surface = videoTrack.getSettings().displaySurface;

                    if (surface !== "monitor") {
                        displayStream.getTracks().forEach(track => track.stop());

                        NotificationHandler(
                            "Please select 'Entire Screen' to continue.",
                            enumUtil.enumtoaster.warning
                        );

                        return;
                    }
                }
                displayStream.getVideoTracks().forEach(track => track.stop());

            } catch (displayErr) {
                // User cancelled the screen share picker — that's fine, just proceed mic-only
                displayStream = null;
            }

            // Stop video tracks immediately — we only need audio
            displayStream?.getVideoTracks().forEach(track => track.stop());

            const hasDisplayAudio = displayStream && displayStream.getAudioTracks().length > 0;

            let finalStream;
            const audioContext = new AudioContext();

            if (hasDisplayAudio) {
                // Mix mic + system audio
                const destination = audioContext.createMediaStreamDestination();
                const displaySource = audioContext.createMediaStreamSource(displayStream);
                const micSource = audioContext.createMediaStreamSource(micStream);

                displaySource.connect(destination);
                micSource.connect(destination);

                finalStream = destination.stream;
            } else {
                // No system audio available — fall back to mic-only
                micStream?.getTracks().forEach(track => track.stop());
                displayStream?.getTracks().forEach(track => track.stop());
                audioContext.close();

                NotificationHandler(
                    "Recording cannot be started because system audio was not shared. Please select 'Entire Screen' and enable 'Share system audio', then try again.",
                    enumUtil.enumtoaster.warning
                );

                return;
            }

            streamRef.current = finalStream;
            streamRef._micStream = micStream;
            streamRef._displayStream = displayStream;
            streamRef._audioContext = audioContext;

            const mediaRecorder = new MediaRecorder(finalStream);
            mediaRecorderRef.current = mediaRecorder;
            chunksRef.current = [];

            mediaRecorder.ondataavailable = (e) => {
                if (e.data.size > 0) chunksRef.current.push(e.data);
            };

            mediaRecorder.onstop = () => {
                if (isDiscardingRef.current) {
                    isDiscardingRef.current = false;
                    chunksRef.current = [];
                    return;
                }
                const blob = new Blob(chunksRef.current, { type: "audio/webm" });
                const url = URL.createObjectURL(blob);
                setAudioURL(url);
                handleUploadAudio(blob);
                setGeneratingTranscript(true);
                audioContext.close();
            };

            mediaRecorder.start();
            setIsRecording(true);
            setIsPaused(false);
            startTimer();

        } catch (err) {
            // Mic itself failed/denied — nothing we can do
            micStream?.getTracks().forEach(t => t.stop());
            displayStream?.getTracks().forEach(t => t.stop());

            if (err.name === 'NotAllowedError') {
                NotificationHandler("Microphone permission denied. Please allow microphone access to start recording.", enumUtil.enumtoaster.error);
            } else {
                NotificationHandler("Could not start recording. Please try again.", enumUtil.enumtoaster.error);
            }
        } finally {
            isStartingRef.current = false;
        }
    };

    //download audio transcript
    const [isLoading, setIsLoading] = useState(false);
    const API_URL_AINoteWorkflows = enumUtil.controller.AINoteWorkflows
    const handleDownloadAudioTranscript = () => {
        setIsLoading(true)
        ServerRequestPublic(API_URL_AINoteWorkflows + "/DownloadEncounterFiles?EncounterID=" + initialData?.Data?.EncounterID, 'GET', '', "Download", '')
            .then((response) => {
                let blob = new Blob([response]);
                saveAs(blob, "AudioTranscript" + ".zip");
                setIsLoading(false)
            }).catch((error) => {
                setIsLoading(false)
                console.log(error);
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
            })
    }


    // next step
    // Get AI Generated Note
    const getAINote = async () => {
        try {
            setIsLoading(true)
            const response = await ServerRequestProtected(
                `${API_URL_AI}/AINote/${initialData?.Data?.ClinicalAINoteJobsID}`,
                "GET"
            );
            setIsLoading(false)
            setGeneratedNotes(response);
            setActiveTab(initialData?.Data?.IsGroupEncounter === "true" ? "Summary" : "note");
            return true;
        } catch (error) {
            setIsLoading(false)
            setGeneratedNotes(null);

            NotificationHandler(
                "Failed to load AI note.",
                enumUtil.enumtoaster.error
            );

            return false;
        }
    };
    const getAIGroupNote = async () => {
        try {
            setIsLoading(true)
            const response = await ServerRequestProtected(
                `${API_URL_AI}/AINoteGrp/${initialData?.Data?.ClinicalAINoteJobsID}`,
                "GET"
            );
            setIsLoading(false)
            setGeneratedNotes(response);
            setActiveTab(initialData?.Data?.IsGroupEncounter === "true" ? "Summary" : "note");
            return true;
        } catch (error) {
            setIsLoading(false)
            setGeneratedNotes(null);
            NotificationHandler("Failed to load AI note.", enumUtil.enumtoaster.error);
            return false;
        }
    }
    // Get AI Generated Transcripted
    const getAITranscript = async () => {
        try {
            setIsLoading(true)
            const response = await ServerRequestProtected(
                `${API_URL_AI}/Transcript/${initialData?.Data?.EncounterID}`,
                "GET"
            );
            setTranscriptedData(response);
            setEmptyTranscript(!response?.transcript);
            setpromptDescription(response.prompt)
            setPromptName(response.promptname || '');
            setIsTranscriptGenerated(true);
            setIsLoading(false)
            return true;
        } catch (error) {
            setIsLoading(false)
            // Show Transcript screen with "No Transcript Found"
            setTranscriptedData({
                transcript: "",
                clinicalAINoteJobsID: "",
                transcriptID: "",
                transcriptStatus: ""
            });
            setEmptyTranscript(true);
            setIsTranscriptGenerated(true);
            setpromptDescription('')
            setPromptName('');
            NotificationHandler(error?.response?.data?.error || "Transcript not found.", enumUtil.enumtoaster.error);
            return false;
        }
    };
    // Get Ai form details (next step to be performed)
    const getAIFormDetails = () => {
        ServerRequestProtected(API_URL + '/AIFormDetails', 'post', {
            "TableName": "Encounter",
            "ID": initialData?.Data.EncounterID
        }
        ).then((response) => {
            setEncounterData(prev => ({
                ...prev,
                Data: {
                    ...prev.Data,
                    ActionToPerform: response.ActionToPerform,
                    ClinicalAINoteJobsID: response.ClinicalAINoteJobsID,
                    AIProcessingStatus: response.AIProcessingStatus
                    // any other fields returned
                }
            }));
        }).catch((error) => {
            setNextStep('')
        })
    }
    const applyActionStep = async (action) => {
        if (isApplyingStepRef.current) return;   // prevent duplicate concurrent runs
        isApplyingStepRef.current = true;
        try {
            setIsTranscriptGenerated(true);
            switch (action) {
                case "GenerateTranscript":
                    setGeneratedNotes(null);
                    setEmptyTranscript(false);
                    setIsTranscriptGenerated(false);
                    setActiveTab("transcript");
                    break;

                case "GenerateNote":
                    setGeneratedNotes(null);
                    setActiveTab("transcript");
                    await getAITranscript();
                    break;

                case "ApplyToEncounter":
                    setActiveTab(initialData?.Data?.IsGroupEncounter === "true" ? "Summary" : "note");
                    const transcriptLoaded = await getAITranscript();
                    if (transcriptLoaded) {
                        if (initialData?.Data?.IsGroupEncounter === 'true') {
                            await getAIGroupNote();
                        } else {
                            await getAINote();
                        }
                    }
                    break;

                default:
                    break;
            }
        } finally {
            isApplyingStepRef.current = false;
        }
    };
    useEffect(() => {
        if (reRecordAI || resumeAI) return;
        const action = initialData?.Data?.ActionToPerform;
        setNextStep(action);
        if (!isNull(action)) applyActionStep(action);
    }, [])
    // useEffect(() => {
    //     if (isNull(nextStep)) return;
    //     const loadData = async () => {
    //         setIsTranscriptGenerated(true)

    //         switch (nextStep) {
    //             case "GenerateTranscript":
    //                 setGeneratedNotes(null);
    //                 setEmptyTranscript(false);
    //                 setIsTranscriptGenerated(false);
    //                 setActiveTab("transcript");
    //                 break;

    //             case "GenerateNote":
    //                 setGeneratedNotes(null);
    //                 setActiveTab("transcript");
    //                 await getAITranscript();
    //                 break;

    //             case "ApplyToEncounter":
    //                 setActiveTab(initialData?.Data?.IsGroupEncounter === "true" ? "Summary" : "note");
    //                 const transcriptLoaded = await getAITranscript();
    //                 if (transcriptLoaded) {
    //                     if (initialData?.Data?.IsGroupEncounter === 'true') {
    //                         await getAIGroupNote()
    //                     } else {
    //                         await getAINote();
    //                     }
    //                 }
    //                 break;
    //             default:
    //                 break;
    //         }
    //     };
    //     loadData();
    // }, [nextStep]);

    // rerecord 
    const resetAIEncounter = ({ dispatchRedux = true } = {}) => {
        // Stop timer
        stopTimer();
        durationRef.current = 0;

        // Abort pending upload
        abortControllerRef.current?.abort();
        abortControllerRef.current = null;

        // Stop recorder safely
        if (mediaRecorderRef.current && mediaRecorderRef.current.state && mediaRecorderRef.current.state !== "inactive") {
            try {
                mediaRecorderRef.current.stop();
            } catch (e) {
                console.log(e);
            }
        }
        mediaRecorderRef.current = null;

        // Stop mixed stream
        if (streamRef.current) {
            try {
                streamRef.current.getTracks().forEach(t => t.stop());
            } catch (e) { }
        }

        // Stop mic stream
        if (streamRef._micStream) {
            try {
                streamRef._micStream.getTracks().forEach(t => t.stop());
            } catch (e) { }
        }

        // Stop display stream
        if (streamRef._displayStream) {
            try {
                streamRef._displayStream.getTracks().forEach(t => t.stop());
            } catch (e) { }
        }
        // Close AudioContext
        if (streamRef._audioContext && streamRef._audioContext.state !== "closed") {
            try {
                streamRef._audioContext.close();
            } catch (e) { }
        }
        streamRef.current = null;
        streamRef._micStream = null;
        streamRef._displayStream = null;
        streamRef._audioContext = null;
        chunksRef.current = [];

        // UI State
        setShowAiEncounterPopup(true)
        setIsRecording(false);
        setIsPaused(false);
        setAudioURL(null);
        setDuration(0);
        setGeneratingTranscript(false);
        setIsTranscriptGenerated(false);
        setEmptyTranscript(false);
        setGeneratedNotes(null);
        setTranscriptedData({
            transcript: "",
            clinicalAINoteJobsID: "",
            transcriptID: "",
            transcriptStatus: ""
        });
        setpromptDescription("");
        setPromptName("");
        setIsPromptExpand(false);
        setisGeneratingNotes({
            generatingNotes: false,
            Progress: null,
            taskStatus: "",
            Message: ""
        });
        setActiveTab("transcript");
        setIsOnlineAppointment(false);
        setNextStep('')
        if (dispatchRedux) {
            dispatch({
                type: "RECORDING_STOPPED",
                payload: { encounterId }
            });
        }
    };
    useEffect(() => {
        if (!reRecordAI) return;

        resetAIEncounter();
        setReRecordAI(false);
    }, [reRecordAI]);
    useEffect(() => {
        if (!resumeAI) return;
        const action = initialData?.Data?.ActionToPerform;
        setNextStep(action);
        if (!isNull(action)) applyActionStep(action);
        setResumeAI(false); // reset the flag once handled
    }, [resumeAI]);
    // Component unmount
    useEffect(() => {
        return () => {
            resetAIEncounter({ dispatchRedux: false });
        };
    }, []);

    useEffect(() => {
        if (openAIPopup && activeRecordingEncounterIdExists + "" === encounterId + "") {
            setShowAiEncounterPopup(true)
            dispatch({ type: "OPEN_AI_POPUP", payload: { openAIPopup: false } }); // deafult ai popup state false
        }
    }, [openAIPopup])

    return (
        <div className={`ar-enconter-ai-note ${showAiEncounterPopup ? "active__notes" : ""}`}>
            {AIDiscardPopup}
            {ATranscriptConfirmationPopup}
            {isLoading ? <Loader /> : null}
            <div className="d-flex flex-column gap-12">
                <div className="d-flex align-items-center justify-content-between px-10">
                    <p className='heading fs-14 dark-clr '>AI Encounter</p>
                    <i className='icon-x-cros fs-20 dark-clr' onClick={closeAudioPopup}></i>
                </div>

                <div className="ar-scroll-content hover-scrollbar px-10">

                    {/* Default Content  */}
                    {isRecording === false && !generatingTranscript && !isTranscriptGenerated && (
                        <div className="ar-Listening-content d-flex flex-column gap-25">
                            <div className="d-flex flex-column gap-3">
                                <div className="d-flex flex-column gap-25 ar_bg-content align-items-center">
                                    <div className="ai-enable-encounter flex-center rounded-5">
                                        <i className='icon-ai-encounter fs-25'></i>
                                    </div>
                                    <div className="text-center">
                                        <p className='heading fs-16 linear-blue-color mb-1'>AI Encounter</p>
                                        <p className='text text-black'>Let AI Encounter assist you in documenting. <br /> Click “Start Listening” and begin speaking.</p>
                                    </div>
                                </div>

                                <div className="d-flex flex-column gap-1">
                                    <label className='d-flex align-items-center gap-6'>
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input p-0 m-0"
                                                id="IsProvider"
                                                name="IsProvider"
                                                autoComplete="off"
                                                checked={isOnlineAppointment}
                                                onChange={(e) => setIsOnlineAppointment(e.target.checked)}
                                            />
                                        </div>
                                        <p className='heading'>Online Appointment</p>
                                    </label>
                                    <p className="text fs-11">Enable this option if this encounter is for an online (telehealth) appointment.</p>
                                </div>
                            </div>

                            <button className='btn btn-Start-Listening flex-center gap-2 rounded-5' onClick={handleStart}>
                                <i className='icon-Voice fs-17'></i>
                                <p className="text text-white fs-13 font-m">Start Listening</p>
                            </button>
                        </div>
                    )}
                    {/* Listening... Content  */}

                    {isRecording && (
                        <div className="ar-Listening-content d-flex flex-column gap-25">
                            <div className="d-flex flex-column gap-25 ar_bg-content align-items-center">
                                {!isPaused ?
                                    <img src="/assets/images/audio.gif" alt="" className='audio-gift' />
                                    : <img src="/assets/images/PauseAudio.svg" alt="" className='' />}

                                <div className="text-center">
                                    <p className='text fs-13 dark-clr'>{formatTime(duration)}</p>
                                    <p className='heading fs-16 linear-blue-color pb-1-5'>{!isPaused ? 'Listening...' : 'Paused'}</p>
                                    <p className='text text-black'>
                                        {!isPaused ?
                                            'Click on “Stop” once the encounter is complete  to generate the note. Maximum recording duration is 120 minutes.'
                                            : 'Click on “Resume” to resume recording. Maximum recording duration is 120 minutes.'
                                        }
                                    </p>
                                </div>
                            </div>
                            {!isPaused ?
                                <div className="px-3 d-flex align-items-center gap-12">
                                    <button className='btn btn-pause flex-center gap-2 rounded-5 w-100 h-32px' onClick={pauseRecording}>
                                        <IconPause />
                                        <p className="text text-black fs-13 font-m">Pause</p>
                                    </button>
                                    <button className='btn btn-Denied flex-center gap-2 rounded-5 w-100 h-32px' onClick={stopRecording}>
                                        <i className='icon-stop fs-10'></i>
                                        <p className="text text-white fs-13 font-m" >Stop</p>
                                    </button>
                                </div>
                                : <button className='btn btn-pause flex-center gap-2 rounded-5 w-100 h-32px' onClick={resumeRecording}>
                                    <i className='icon-Resume fs-13'></i>
                                    <p className="text text-black fs-13 font-m">Resume</p>
                                </button>
                            }
                        </div>
                    )}

                    <Modal show={generatingTranscript} onHide={generatingTranscript} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_genrate-tarnscript-popup">

                        <Modal.Body>
                            <div className="d-flex align-items-center justify-content-between mb-12">
                                <p className='heading fs-14 dark-clr '>Generating Transcript</p>
                                {/* <i className='icon-x-cros fs-20 dark-clr' onClick={handleCloseAudioPopup}></i> */}
                            </div>

                            <div className="ar-Listening-content d-flex flex-column gap-25">
                                <div className="Loader-content">
                                    <div className="d-flex flex-column gap-15 ar_bg-content align-items-center">
                                        <img src="/assets/images/GenratingScript.svg" alt="" className='' />

                                        <div className="text-center px-4">
                                            <p className='text fs-15 text-black mb-1 font-m'>{initialData?.Data?.NoteType} is being <span className="generating-transcript linear-blue-color">Generated</span></p>
                                            <p className='text text-black fs-11 fw-light'>This may take few seconds. Please don’t close this window.</p>
                                        </div>
                                        <div className="Review-content d-flex align-items-center gap-1">
                                            <IconAiSingle />
                                            <p className='text fs-9'>AI-content may contain inaccuracies. Review before finalizing.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>

                    {/* Transcript & Note ... Content  */}

                    {isTranscriptGenerated && (
                        <div className="ar-summary-tabs_content">
                            <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
                                <Nav variant="tabs" className="d-flex border-0 gx-0 align-items-center gap-1 mb-12">
                                    <Nav.Item className="ar-copay-link ar-pad">
                                        <Nav.Link eventKey='transcript' className="text font-m">Transcript</Nav.Link>
                                    </Nav.Item>
                                    {!!generatedNotes && initialData?.Data?.IsGroupEncounter !== 'true' &&
                                        <Nav.Item className="ar-copay-link ar-pad">
                                            <Nav.Link eventKey="note" className="text font-m">Note</Nav.Link>
                                        </Nav.Item>}
                                    {!!generatedNotes && initialData?.Data?.IsGroupEncounter === 'true' &&
                                        <Nav.Item className="ar-copay-link ar-pad">
                                            <Nav.Link eventKey="Summary" className="text font-m">Summary</Nav.Link>
                                        </Nav.Item>}
                                </Nav>
                                <Tab.Content>
                                    <Tab.Pane eventKey='transcript'>
                                        <div className="ar-scroll-content hover-scrollbar d-flex flex-column justify-content-between">
                                            {/* {isGeneratingNotes.generatingNotes ? */}
                                            <Modal show={generatingTranscript || isGeneratingNotes?.generatingNotes} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_genrate-tarnscript-popup">
                                                <Modal.Body>
                                                    <div className="d-flex align-items-center justify-content-between mb-12">
                                                        <p className='heading fs-14 dark-clr '>
                                                            {initialData?.Data?.IsGroupEncounter === 'true' ? 'Generating Summary' : 'Generating Note'}
                                                        </p>
                                                        {/* <i className='icon-x-cros fs-20 dark-clr' onClick={handleCloseAudioPopup}></i> */}
                                                    </div>

                                                    <div className="ar-Listening-content d-flex flex-column gap-25">
                                                        <div className="Loader-content">
                                                            <div className="d-flex flex-column gap-15 ar_bg-content align-items-center">
                                                                <img src="/assets/images/GenratingScript.svg" alt="" className='' />

                                                                <div className="text-center px-4">
                                                                    <p className='text fs-15 text-black mb-1 font-m'>{initialData?.Data?.NoteType} is being <span className="generating-transcript linear-blue-color">Generating </span></p>
                                                                    <p className='text text-black fs-11 fw-light'>This may take few seconds. Please don’t close this window.</p>
                                                                </div>
                                                                <div className="Review-content d-flex align-items-center gap-1">
                                                                    <IconAiSingle />
                                                                    <p className='text fs-9'>AI-content may contain inaccuracies. Review before finalizing.</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Modal.Body>
                                            </Modal>
                                            {/* : */}
                                            <div className="d-flex flex-column gap-2">
                                                <div className="ar_bg-content p-2 d-flex flex-column gap-6">
                                                    <div className="d-flex align-items-center justify-content-between">
                                                        <p className="heading fs-13 text-black">Stopped...</p>
                                                        <p className="text fs-11 dark-clr">Total Session Time: {formatTime(duration)}</p>
                                                    </div>
                                                    <p className='text text-black fs-11 lh-normal'>
                                                        {initialData?.Data?.IsGroupEncounter === 'true' ?
                                                            'Generate speaker summaries to assign each speaker to a patient before generating clinical notes.' :
                                                            'Review the conversation below before generating the clinical note.'}
                                                    </p>

                                                    {/* For Group Ai Encounter  */}
                                                    {/* <p className='text text-black fs-11 lh-normal'>8 speakers detected. Generate speaker summaries to assign each speaker to a patient before generating clinical notes.</p> */}
                                                </div>
                                                {/* {transcriptedData?.transcript &&
                                                        <div className="ar_bg-content p-2 d-flex flex-column gap-6">
                                                            <div className="d-flex gap-1">
                                                                <span className="d-flex mt-3px">
                                                                    <IconAlertGradient />
                                                                </span>
                                                                <p className='text lh-normal'>
                                                                    <span className="linear-blue-color font-sb text-decoration-underline cursor-pointer" onClick={handleDownloadAudioTranscript}>Click Here</span>
                                                                    <span className="font-sb"> to download the session audio and transcript.</span> A download link will be sent to your registered email address.
                                                                </p>
                                                            </div>
                                                        </div>
                                                    } */}

                                                <div className="d-flex flex-column gap-1">
                                                    {transcriptedData?.transcript &&
                                                        transcriptedData.transcript.split('\n').map((line, idx) => {
                                                            const [Speaker, ...rest] = line.replace(/\\b/g, '\b').split('\b');
                                                            const message = rest.join('');
                                                            return (
                                                                <p key={idx} className="text fs-11">
                                                                    {Speaker && <span className="font-sb">{Speaker}</span>}
                                                                    {message}
                                                                </p>
                                                            );
                                                        })}
                                                    {emptyTranscript ? <p className="text fs-11">
                                                        <span className="font-sb"> No Transcription Found</span>
                                                    </p> : ''}
                                                </div>
                                            </div>
                                            {/* } */}
                                            {!isNull(promptName) ?
                                                <div className="position-sticky bottom-0 bg-white pt-1 d-flex flex-column gap-2">
                                                    <div className="ar_bg-content p-2 d-flex flex-column gap-6 prompt-View">
                                                        <div className="d-flex align-items-center justify-content-between gap-2 user-select-none cursor-pointer" onClick={() => setIsPromptExpand(!isPromptExpand)}>
                                                            <p className="text validation_message min-w-0"><span className="font-sb">Prompt Name:</span> {promptName || `${initialData?.Data?.NoteType}`} Prompt</p>
                                                            {isPromptExpand ? <i className="icon-up fs-8 theme-clr"></i> : <i className="icon-down fs-8 theme-clr"></i>}
                                                        </div>
                                                        {isPromptExpand ?
                                                            <div className="input m-0">
                                                                <textarea
                                                                    rows={8}
                                                                    value={promptDescription}
                                                                    id="promptDescription"
                                                                    name="promptDescription"
                                                                    className="form-control"
                                                                    onChange={(e) => setpromptDescription(e.target.value)}
                                                                />
                                                            </div>
                                                            :
                                                            null}
                                                    </div>
                                                    {isGeneratingNotes.generatingNotes === false ?
                                                        (generatedNotes ? null :
                                                            <div onClick={GenerateNotes} className="mx-20">
                                                                <button className='btn btn-Start-Listening flex-center rounded-5 w-100 h-32px flex-shrink-0'>
                                                                    <p className="text text-white fs-13 font-m" disabled={isGeneratingNotes.generatingNotes}>
                                                                        {initialData?.Data?.IsGroupEncounter === 'true' ? 'Generate Summary' : 'Generate Note'}
                                                                    </p>
                                                                </button>
                                                            </div>)
                                                        : null}
                                                </div>
                                                : null}
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="note" >
                                        <div className="ar-scroll-content hover-scrollbar d-flex flex-column gap-2 justify-content-between">
                                            <div className="d-flex flex-column gap-2">
                                                <div className="ar_bg-content p-2 d-flex flex-column gap-6">
                                                    <div className="d-flex align-items-center gap-1">
                                                        <IconAlertGradient />
                                                        <p className="heading fs-13 text-black">Manual Review Required</p>
                                                    </div>
                                                    <p className='text text-black fs-11 lh-normal'>AI-generated content may not include all sections required for this note type. Please review and complete any missing sections before finalizing the encounter.</p>
                                                </div>
                                                {generatedNotes &&
                                                    <AIEncounterTranscriptPreview generatedNotes={generatedNotes} />}
                                            </div>
                                            <div className="position-sticky bottom-0 bg-white pt-1 px-20" onClick={AddEncounter}>
                                                <button className='btn btn-Start-Listening flex-center rounded-5 w-100 h-32px flex-shrink-0'>
                                                    <p className="text text-white fs-13 font-m" >Add to Encounter</p>
                                                </button>
                                            </div>
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="Summary" >
                                        <div className="ar-scroll-content hover-scrollbar d-flex flex-column gap-2 justify-content-between">
                                            <div className="d-flex flex-column gap-2">
                                                <div className="ar_bg-content p-2 d-flex flex-column gap-6">
                                                    <div className="d-flex align-items-center gap-1">
                                                        <IconAlertGradient />
                                                        <p className="heading fs-13 text-black">Manual Review Required</p>
                                                    </div>
                                                    <p className='text text-black fs-11 lh-normal'>AI-generated content may contain inaccuracies. Please review the group summary and verify that each speaker summary is assigned to the appropriate patient before finalizing the encounter.</p>
                                                </div>
                                                {generatedNotes &&
                                                    <AIEncounterSummaryPreview generatedNotes={generatedNotes} setGeneratedNotes={setGeneratedNotes} initialData={initialData} />
                                                }
                                            </div>
                                            <div className="position-sticky bottom-0 bg-white pt-1 px-20" onClick={AddEncounter}>
                                                <button className='btn btn-Start-Listening flex-center rounded-5 w-100 h-32px flex-shrink-0'>
                                                    <p className="text text-white fs-13 font-m" >Add to Encounter</p>
                                                </button>
                                            </div>
                                        </div>

                                    </Tab.Pane>
                                </Tab.Content>
                            </Tab.Container>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default AIEncounter